import React, { FC } from "react"
import "./style.sass"
import styled from "styled-components"
import insuranceAgency from "../../static/icons/insurance_agency-icon.png"
import markNumberOne from "../../static/icons/mark-number-one.png"
import napf from "../../static/icons/napf.png"

const FooterWrapper = styled.div`
  padding: 64px 0;

  @media screen and (min-width: 768px) {
    padding: 64px 70px;
  }

  @media screen and (min-width: 1024px) {
    background: #f0f3f6;
  }

  .columns {
    grid-row-gap: 0;
  }

  .container {
    max-width: 1220px;
  }

  .col {
    padding: 0;
  }

  .col_lg-5 {
    @media screen and (min-width: 1024px) {
      display: flex;
      justify-content: flex-end;

      & > div > ul:first-child {
        width: 140px;
      }
    }
  }
`

export const Footer: FC = () => {
  return (
    <FooterWrapper className="footer-wrap">
      <div className="section">
        <div className="container">
          <div className="columns">
            <div className="col col_xs-4 col_md-8 col_lg-7">
              <div className="expanded-menu">
                <ul className="expanded-menu__list">
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/"
                    >
                      <strong>О фонде</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/"
                    >
                      О работе фонда
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/#found-number"
                    >
                      Фонд в цифрах
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/#awards"
                    >
                      Награды
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/#management"
                    >
                      Руководство
                    </a>
                  </li>
                </ul>
                <ul className="expanded-menu__list">
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/services/"
                    >
                      <strong>Сервисы</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://lk.npfsb.ru/"
                    >
                      Личный кабинет
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npo.npfsb.ru/?landing=npo&amp;step=1&amp;_ga=2.200529069.243163990.1600838420-1760634733.1595856327"
                    >
                      Оформить пенсионный план
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://lk.npfsb.ru/formirovanie-zajavlenija-po-forme-04-f?_ga=2.266833806.1228887103.1589186614-400521983.1587306349"
                    >
                      Оформление заявления правопреемника
                    </a>
                  </li>
                </ul>
                <ul className="expanded-menu__list">
                  <li className="expanded-menu__item">
                    <a className="expanded-menu__link" href="#">
                      <strong>Частным клиентам</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/ipp/"
                    >
                      Индивидуальные пенсионные планы
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/ops/"
                    >
                      Обязательное пенсионное страхование
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/information-to-be-disclosed/#files"
                    >
                      Документы
                    </a>
                  </li>
                  <li className="expanded-menu__item d-desktop-none">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/faq/"
                    >
                      Вопросы и ответы
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col_xs-4 col_md-8 col_lg-5">
              <div className="expanded-menu expanded-menu_last">
                <ul className="expanded-menu__list">
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/business/"
                    >
                      <strong>Корпоративным клиентам</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/about/#investment"
                    >
                      <strong>Инвестиционная деятельность</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/upload/safety_recommendations.pdf"
                    >
                      <strong>Рекомендации по защите информации</strong>
                    </a>
                  </li>
                </ul>
                <ul className="expanded-menu__list">
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/contacts/"
                    >
                      <strong>Контакты</strong>
                    </a>
                  </li>
                  <li className="expanded-menu__item">
                    <a
                      className="expanded-menu__link"
                      href="https://npfsberbanka.ru/news/"
                    >
                      <strong>Публикации</strong>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-phone">
                <div className="footer-phone__phone heading-font">
                  <a href="tel:84957847370">8 (495) 784-73-70</a>
                </div>
                <div className="footer-phone__note">
                  Для бесплатных звонков с любых телефонов на территории России
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <footer className="footer">
            <div className="footer__wrapper">
              <div className="footer__copy">
                © 2009–2020 Акционерное общество «Негосударственный Пенсионный
                Фонд Сбербанка»
                <br />
                Лицензия №41/2 от 16.06.2009 г. выдана Федеральной службой по
                финансовым рынкам.
                <br />
                ИНН/ КПП 7725352740/772501001, ОГРН 1147799009160
                <div className="footer__logo-container">
                  <a
                    className="footer__logo-link"
                    href="http://www.asv.org.ru/"
                    title="Агентство по страхованию вкладов"
                    target="_blank"
                  >
                    <img src={insuranceAgency} alt="" />
                  </a>
                  <a
                    className="footer__logo-link"
                    href="https://npfsberbanka.ru/news/17891/"
                    title="Марка номер 1"
                    target="_blank"
                  >
                    <img src={markNumberOne} alt="" />
                  </a>
                  <a
                    className="footer__logo-link"
                    href="http://napf.ru/"
                    title="Национальная ассоциация негосударственных пенсионных фондов "
                    target="_blank"
                  >
                    <img src={napf} alt="" />
                  </a>
                </div>
              </div>
              <div className="footer__content">
                <p>
                  <a
                    target="_blank"
                    href="https://npfsberbanka.ru/upload/ACB.pdf"
                  >
                    Свидетельство №2
                  </a>
                  &nbsp; о внесении в реестр негосударственных пенсионных фондов
                  - участников системы гарантирования прав застрахованных лиц в
                  системе обязательного пенсионного страхования. Воспроизведение
                  материалов сайта возможно только с указанием ссылки на
                  источник.
                </p>
                <br />
                <p>
                  <a
                    target="_blank"
                    href="https://npfsberbanka.ru/upload/spisok_lic_290920_1.pdf"
                  >
                    Информация о лицах, под контролем либо значительным влиянием
                    которых находится АО «НПФ Сбербанка»
                  </a>
                </p>
                <br />
                <p>
                  Сайт
                  <a className="link" href="https://npfsberbanka.ru/">
                    &nbsp; npfsberbanka.ru
                  </a>
                  &nbsp; зарегистрирован как СМИ, &nbsp;
                  <a
                    target="_blank"
                    href="https://npfsberbanka.ru/upload/Svid.pdf"
                  >
                    ЭЛ №ФС77-63615
                  </a>
                  &nbsp; от 2 ноября 2015 года. info@npfsb.ru
                </p>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </FooterWrapper>
  )
}
